import { formatHours } from "@/lib/api";

export default function CapacityBar({ used, schedulable, total, label }) {
  const pct = schedulable > 0 ? Math.min(100, (used / schedulable) * 100) : 0;
  const ratioPct = total > 0 ? (schedulable / total) * 100 : 0;
  const isFull = pct >= 100 && schedulable > 0;

  return (
    <div className="space-y-2" data-testid="capacity-progress-bar">
      <div className="flex items-baseline justify-between">
        <span className="text-sm font-medium text-slate-700">{label}</span>
        <span className="text-sm text-slate-500">
          <span className="font-semibold text-slate-900">{formatHours(used)}</span>
          {" / "}
          {formatHours(schedulable)} programables
          <span className="text-slate-400"> (de {formatHours(total)})</span>
        </span>
      </div>
      <div className="cap-bar" style={{ position: "relative" }}>
        <div
          className="cap-bar-fill"
          style={{
            width: `${pct}%`,
            backgroundColor: isFull ? "#dc2626" : "#2563eb",
          }}
        />
        {total > 0 && (
          <div
            style={{
              position: "absolute",
              top: 0,
              bottom: 0,
              left: `${ratioPct}%`,
              width: "2px",
              backgroundColor: "#f59e0b",
            }}
            title="Límite programable"
          />
        )}
      </div>
    </div>
  );
}
